// extracted by mini-css-extract-plugin
export var divider = "_cf-7";
export var itemsToggle = "_cf-8";
export var mergeModal = "_cf-1";
export var optionCard = "_cf-4";
export var radioGroup = "_cf-6";
export var radioOption = "_cf-0";
export var selected = "_cf-5";
export var shipmentOptions = "_cf-2";
export var tableOptions = "_cf-3";